export default __webpack_public_path__ + "static/media/Scenario-window.d0135816.png";